import { PLAYER_ENV } from 'environment';

angular
  .module('app.directives')
  .directive('lowLatencyPlayer', function($timeout) {
    'ngInject';

    return {
      restrict: 'E',
      scope: { broadcast: '=' },
      template: `
        <div id="{{:: id}}" class="player"></div>
        <div ng-if="no_op" class="bg-warning text-warning text-center" style="border:1px solid;margin:45px 15px 15px 15px;padding:15px;">
          Flash is required to view the low latency preview.
          <a href="https://get.adobe.com/flashplayer" target="_blank">
            Click to enable or download Flash
          </a>
        </div>
      `,
      link(scope, element, attrs, ngModel) {
        scope.id = `player-${0|(Math.random()*1000000)}`;
        scope.no_op = false;

        let ctx = boxcast(`#${scope.id}`);
        scope.$watch(() => scope.broadcast && scope.broadcast.rtmp_preview_url, function(rtmp_preview_url) {
          if (rtmp_preview_url) {
            ctx.unload();
            ctx.loadLowLatency(rtmp_preview_url, {
              disableMetrics: true,
              debug: true,
              env: PLAYER_ENV,
              onLoadPlayer: (p) => {
                if (p.core.getCurrentPlayback().name == 'no_op') {
                  ctx.unload();
                  scope.$evalAsync(() => scope.no_op = true);
                  if (canRequestPermission) {
                    // in case, when flash is not available, try to prompt user to enable it
                    requestFlashPermission();
                    // Chrome requires user's click in order to allow iframe embeding
                    $(window).one('click', requestFlashPermission);
                  }
                }
              }
            });
          } else {
            ctx.unload();
          }
        });

        scope.$on('$destroy', () => {
          if (ctx) ctx.unload();
        });
      }
    };
  });


/**
 * Tries to show browser's promt for enabling flash
 *
 * Chrome starting from 56 version and Edge from 15 are disabling flash
 * by default. To promt user to enable flash, they suggest to send user to
 * flash player download page. Then this browser will catch such request
 * and show a promt to user:
 * https://www.chromium.org/flash-roadmap#TOC-Developer-Recommendations
 * In this method we are forcing such promt by navigating user to adobe
 * site in iframe, instead of top window
 */
function requestFlashPermission() {
    var iframe = document.createElement('iframe');
    iframe.src = 'https://get.adobe.com/flashplayer';
    iframe.sandbox = '';
    document.body.appendChild(iframe);
    document.body.removeChild(iframe);
}


var isNewEdge = (navigator.userAgent.match(/Edge\/(\d+)/) || [])[1] > 14;
var isNewSafari = (navigator.userAgent.match(/OS X (\d+)/) || [])[1] > 9;
var isNewChrome = (navigator.userAgent.match(/Chrom(e|ium)\/(\d+)/) || [])[2] > 56
    && !/Mobile/i.test(navigator.userAgent);
var canRequestPermission = isNewEdge || isNewSafari || isNewChrome;


// WEBPACK FOOTER //
// ./directives/low-latency-player.js